import React from 'react';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { useGlobal } from '@/utils/useGlobal';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';
import { useMediaDevice } from '../Brands/hooks';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import MinTitle from '../MinTitle';
function Explore() {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="direction-right">
                <path id="Vector" d="M8 5.58398L13 10.584L8 15.584" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
}
const linkObj: any = {
    eu: 'https://www.ecoflow.com/eu/oasis-home-energy-management-system',
    fr: 'https://www.ecoflow.com/fr/oasis-home-energy-management-system',
    de: 'https://www.ecoflow.com/de/oasis-home-energy-management-system',
    it: 'https://www.ecoflow.com/it/oasis-home-energy-management-system',
    es: 'https://www.ecoflow.com/es/oasis-home-energy-management-system',
    uk: 'https://www.ecoflow.com/uk/oasis-home-energy-management-system',
};
const localeData: any = {
    eu: {
        img1: 'https://websiteoss.ecoflow.com/upload/image/1747102005442/%E9%A6%96%E9%A1%B5_eu.png',
        img2: 'https://websiteoss.ecoflow.com/upload/image/1747102005044/AI%E5%8A%A9%E6%89%8B_eu.png',
        img3: 'https://websiteoss.ecoflow.com/upload/image/1747102004857/%E8%83%BD%E6%BA%90%E6%8A%A5%E5%91%8A_eu.png',
        img4: 'https://websiteoss.ecoflow.com/upload/image/1747102005272/%E7%94%A8%E7%94%B5%E5%BB%BA%E8%AE%AE_eu.png',
    },
    de: {
        img1: 'https://websiteoss.ecoflow.com/upload/image/1747102277452/%E9%A6%96%E9%A1%B5_DE.png',
        img2: 'https://websiteoss.ecoflow.com/upload/image/1747102277928/AI%E5%8A%A9%E6%89%8B_DE.png',
        img3: 'https://websiteoss.ecoflow.com/upload/image/1747102277257/%E8%83%BD%E6%BA%90%E6%8A%A5%E5%91%8A_DE.png',
        img4: 'https://websiteoss.ecoflow.com/upload/image/1747102277760/%E7%94%A8%E7%94%B5%E5%BB%BA%E8%AE%AE_DE.png',
    },
};
export default function Assistant({ pageType = 'normal' }) {
    const { locale } = getLocal();
    const { gtm } = useGlobal();
    const { t } = useLang('theProduct.Assistant');
    const { isH5, isPad } = useMediaDevice();

    const handlerLink = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: t('oasis'),
                url: linkObj[locale],
            });
        } catch (error) {
            console.log(error, 'error-158');
        }
        window.open(linkObj[locale], '_blank');
    };
    const targetData = localeData[locale] || localeData['eu'];
    let title = t.rich('title', {
        sup: (text: string) => <span className="math-emoji">{text}</span>,
    });
    if (pageType === 'ultra') {
        title = t('ultra_title');
    } else if (pageType === 'ac') {
        title = t('ac_title');
    }
    const arr = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            type: 'img',
            h5: targetData.img1,
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            type: 'img',
            h5: targetData.img2,
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            type: 'img',
            h5: targetData.img3,
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            type: 'img',
            h5: targetData.img4,
        },
    ];

    return (
        <div className={styles.Assistant}>
            <div className="assistant-container">
                <MinTitle title={t('save_easy')} align="center" />

                <EcoSection subTitle={t('subTitle')} title={title} className="product-section assistant-section" subTitleColor="#83868D" />
                {isH5 ? (
                    <Swiper
                        className="assistant-swiper"
                        modules={[Navigation]}
                        spaceBetween={16}
                        navigation={false}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 24,
                            snapOnRelease: true,
                        }}
                    >
                        {arr.map((item: any, index: number) => (
                            <SwiperSlide className="assistant-slide-item" key={index}>
                                <div className="assistant-item">
                                    <div className="img">
                                        <EcoImg pc={item.h5} isOpenLazy />
                                    </div>
                                    <div className="item-title">{item.title}</div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div className="img-box">
                        <div className="img-box-item">
                            <div className="img-item">
                                <EcoImg pc={targetData.img1} h5={targetData.img1} isOpenLazy />
                            </div>

                            <p className="img-desc">{t('item1_title')}</p>
                        </div>
                        <div className="img-box-item">
                            <div className="img-item">
                                <EcoImg pc={targetData.img2} h5={targetData.img2} isOpenLazy />
                            </div>
                            <p className="img-desc">{t('item2_title')}</p>
                        </div>
                        <div className="img-box-item">
                            <div className="img-item">
                                <EcoImg pc={targetData.img3} h5={targetData.img3} isOpenLazy />
                            </div>
                            <p className="img-desc">{t('item3_title')}</p>
                        </div>
                        <div className="img-box-item">
                            <div className="img-item">
                                <EcoImg pc={targetData.img4} h5={targetData.img4} isOpenLazy />
                            </div>
                            <p className="img-desc">{t('item4_title')}</p>
                        </div>
                    </div>
                )}

                <div className="explore-oasis">
                    <span>{t('save_app')}</span>
                    <span onClick={handlerLink} className="blue">
                        {t('explore')}
                        <Explore />
                    </span>
                </div>
            </div>
        </div>
    );
}
